import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import { DateField, Show, Typography } from "@pankod/refine-antd";

import { IUser } from "interfaces";

const { Title, Text } = Typography;

export const UserShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow<IUser>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>ID</Title>
      <Text>{record?.id}</Text>
      <Title level={5}>Nombre</Title>
      <Text>{record?.name}</Text>
      <Title level={5}>Usuario</Title>
      <Text>{record?.username}</Text>
      <Title level={5}>Fecha de creación</Title>
      <DateField value={record?.created_at} format="LLL" />
    </Show>
  );
};
